import api from './api';

const commissionService = {
  getAll: async () => {
    const response = await api.get('/commissions');
    return response.data;
  },

  getMine: async () => {
    const response = await api.get('/commissions/mine');
    return response.data;
  },

  getBySalesman: async (salesmanId) => {
    const response = await api.get(`/commissions/salesman/${salesmanId}`);
    return response.data;
  },

  getSummary: async (salesmanId) => {
    const response = await api.get(`/commissions/salesman/${salesmanId}/summary`);
    return response.data;
  },

  markAsPaid: async (id) => {
    const response = await api.put(`/commissions/${id}/pay`);
    return response.data;
  },

  getSalesmen: async () => {
    const response = await api.get('/commissions/salesmen');
    return response.data;
  },

  createSalesman: async (salesmanData) => {
    const response = await api.post('/commissions/salesmen', salesmanData);
    return response.data;
  },

  updateRate: async (id, rate) => {
    const response = await api.put(`/commissions/salesmen/${id}/rate`, { commission_percentage: rate });
    return response.data;
  },
};

export default commissionService;
